import { ɵisAnalyticsSupportedFactory } from '@angular/fire';

export const isSupported = ɵisAnalyticsSupportedFactory.async;
